export const externalIntegrationsEnabled = process.env.REACT_APP_EXTERNAL_INTEGRATIONS !== "false";
export const deliveryAddress = raw => {
  let address = raw;
  if (typeof address === "string") {
    try {address = JSON.parse(address);} catch {return "";}
  }
  if (!address || typeof address !== "object") return "";
  return [address.street, address.zipCode, address.city, address.state, address.country]
    .filter(value => typeof value === "string" || typeof value === "number")
    .map(value => String(value).trim()).filter(Boolean).join(", ");
};
export const directionsUrl = address => {
  const destination = deliveryAddress(address);
  return destination ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}` : null;
};
